import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Button,
  makeStyles,
  Grid,
} from "@material-ui/core";
import { Select } from "@ofqual/portal-components/components/Select";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FoiItem } from "../../../../domain/FoiItem";
import { authSelector } from "../../../../redux/selectors";
import {
  complaintSourcesService,
  complaintsService,
  complaintTypeService,
} from "../../../../services";
import { ComplaintRequiredItem } from "../../../../services/ComplaintsService";
import { PeRequiredItem } from "../../../../services/PeService";
import { Error } from "../../../common/Error";
//import { assignCase, unassignCase } from "../../../../redux/actions";

const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: 15,
  },
}));

export const CreateComplaintDialog: React.FC<{ foiItem: FoiItem }> = ({
  foiItem,
}) => {
  const classes = useStyles();
  const { token } = useSelector(authSelector);
  const { handleSubmit, control, errors } = useForm();
  const { push } = useHistory();

  const [complainstSourceLookups, complaintsTypeLookups] = useLookup(
    complaintSourcesService,
    complaintTypeService
  );

  const onSubmit = async (requiredCaseItem: ComplaintRequiredItem) => {
    const res = await complaintsService.createComplaint(foiItem.id, requiredCaseItem, {
      token,
    });
    if (res.status === 409) {
      console.log("FOI Already used to create a Complaint");
    } else {
      push(`/complaints/${res.data}`);
    }
  };

  return (
    <>
      <form>
        <DialogTitle data-test="assign-ctr-dialog-title">
          Transfer this FOI to a Complaint
          <Divider />
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="source"
                defaultValue={null}
                rules={{ required: true }}
                as={
                  <Select
                    label="Source"
                    datatest="transfer-source-type-field"
                    required
                  >
                    {complainstSourceLookups}
                  </Select>
                }
              />
              {errors.source && (
                <Error data-test="transfer-source-type-field-validation">
                  This field is required
                </Error>
              )}
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="caseType"
                defaultValue={null}
                rules={{ required: true }}
                as={
                  <Select
                    label="Case type"
                    datatest="transfer-case-type-field"
                    required
                  >
                    {complaintsTypeLookups}
                  </Select>
                }
              />
              {errors.caseType && (
                <Error data-test="transfer-case-type-field-validation">
                  This field is required
                </Error>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={handleSubmit((data: PeRequiredItem) => onSubmit(data))}
            color="primary"
            data-test="confirm-transfer-button"
          >
            Confirm
          </Button>
        </DialogActions>
      </form>
    </>
  );
};
